/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Animal } from '../../models/animal';

export interface GetAnimalsForCustomer$Params {
  id: string;

/**
 * Should the query result include the customer's dead animals?
 */
  withDeadAnimals?: boolean;

/**
 * Should the query result include inactive animals
 */
  withInactive?: boolean;
}

export function getAnimalsForCustomer(http: HttpClient, rootUrl: string, params: GetAnimalsForCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Animal>>> {
  const rb = new RequestBuilder(rootUrl, getAnimalsForCustomer.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('withDeadAnimals', params.withDeadAnimals, {});
    rb.query('withInactive', params.withInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Animal>>;
    })
  );
}

getAnimalsForCustomer.PATH = '/api/customers/{id}/animals';
